<template>
  <div>
    <div class="inputCard">
      <header>About Page Main</header>
      <div class="content">
        <div class="cardRow w3-padding-8">
          <label class="w3-label">About Page Type</label>
          <select class="w3-select w3-border" v-model="state.siteData.pages.about.type">
            <option value="sidebar">Sidebar</option>
            <option value="fullwidth">Full Width</option>
          </select>
        </div>
        <div class="cardRow w3-padding-8">
          <label class="w3-label">Page Enabled?</label>
          <div class="w3-right-align">
            <label class="switch">
              <input type="checkbox" v-model="state.siteData.pages.about.enabled">
              <span class="slider"></span>
            </label>
          </div>
        </div>
        <div class="cardRow w3-padding-8">
          <label>Page URL</label>
          <input v-model="state.siteData.pages.about.url" class="w3-input w3-border" />
        </div>
      </div>
    </div>
    <div class="inputCard">
      <header style="border-radius:5px 5px 5px 5px"><i class="mr-2 fa w3-small"></i>About Page SEO</header>
      <div class="content">
        <div class="cardRow w3-padding-8">
          <label>Page Title</label>
          <input v-model="state.siteData.pages.about.seo.title" class="w3-input w3-border" />
        </div>
        <div class="cardRow w3-padding-8">
          <label>Page Keywords</label>
          <input v-model="state.siteData.pages.about.seo.keywords" class="w3-input w3-border" />
        </div>
        <div class="cardRow w3-padding-8">
          <label>Page Description</label>
          <input v-model="state.siteData.pages.about.seo.description" class="w3-input w3-border" />
        </div>
      </div>
    </div>
    <div class="inputCard" v-if="state.siteData.pages.about.type === 'sidebar'">
      <header>Sidebar</header>
      <div class="content">
        <div class="cardRow w3-padding-8">
          <label>Show Partners</label>
          <div class="w3-right-align">
            <label class="switch">
              <input type="checkbox" v-model="state.siteData.pages.about.partners">
              <span class="slider"></span>
            </label>
          </div>
        </div>
      </div>
    </div>
    <div class="inputCard">
      <header>Content</header>
      <div class="content">
        <div class="input-row w3-padding-8">
          <tinymce-editor api-key="t5p4kok2r7znye5exinvmcmpazco8x8rd3hoapujd41dps8c" :init="state.tinymceInit" v-model="state.siteData.pages.about.content.main"></tinymce-editor>
        </div>
      </div>
    </div>
    <div class="inputCard">
      <header>Custom Content</header>
      <div class="content">
        <div class="input-row w3-padding-8">
          <tinymce-editor api-key="t5p4kok2r7znye5exinvmcmpazco8x8rd3hoapujd41dps8c" :init="state.tinymceInit" v-model="state.siteData.pages.about.content.custom"></tinymce-editor>
        </div>
      </div>
    </div>
    <div class="inputCard">
      <header class="w3-left-align">Page Image</header>
      <div class="content">
        <div class="cardRow w3-padding-8" style="border-bottom:0;">
          <label style="margin-top:6px;">Image Alt Tag</label>
          <input v-model="state.siteData.pages.about.image.alt" placeholder="Image Description" class="w3-input w3-border" />
        </div>
        <div class="cardRow w3-padding-8" style="border-bottom:0;">
          <label style="margin-top:6px;">Image</label>
          <div class="w3-right-align">
            <label for="aboutPageFile" class="w3-button w3-green w3-small" style="margin-top:0;">Upload Image</label>
            <input id="aboutPageFile" type="file" @change="uploadPageImage('about', $event.target.files)" ref="fileUpload" accept=".png,.jpg" class="inputFile" />
            <button class="w3-button w3-red w3-round w3-small" @click="deletePageImage('about')">Delete</button>
          </div>
        </div>
        <div class="w3-center w3-border-bottom w3-padding-bottom">
          <img v-if="state.siteData.pages.about.image.src !== ''" :src="state.siteData.pages.about.image.src" style="width:100%; max-width:300px;" />
        </div>
      </div>
    </div>
    <div class="inputCard" v-if="state.siteData.pageHeader.type === 'background-fixed'">
      <header class="w3-left-align">Page Header Background Image</header>
      <div class="content">
        <div class="cardRow w3-padding-8" style="border-bottom:0;">
          <div class="w3-right-align">
            <label for="aboutPageHeaderFile" class="w3-button w3-green w3-small" style="margin-top:0;">Upload Image</label>
            <input id="aboutPageHeaderFile" type="file" @change="uploadPageHeaderImage('about', $event.target.files)" ref="fileUpload" accept=".png,.jpg" class="inputFile" />
          </div>
        </div>
        <div class="w3-center w3-border-bottom w3-padding-bottom">
          <img v-if="state.siteData.pages.about.headerBG !== ''" :src="state.siteData.pages.about.headerBG" style="width:100%; max-width:300px;" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  var dataStore = require('@/dataStore').default
  import Editor from '@tinymce/tinymce-vue'

  export default {
    name: 'cmsPagesAbout',
    data() {
      return {
        state: dataStore.state
      }
    },
    components: {
      'tinymce-editor': Editor
    },
    methods: {
      uploadPageImage(type, files) {
        dataStore.uploadImage(files).then((path) => {
          this.state.siteData.pages[type].image.src = path
        })
      },
      deletePageImage(page) {
        this.state.siteData.pages[page].image.src = ''
      },
      uploadPageHeaderImage(type, files) {
        dataStore.uploadImage(files).then((path) => {
          this.state.siteData.pages[type].headerBG = path
        })
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/cms/pages/about/cmsPagesAbout.vue